import { html } from 'lit-element';
import AabSelectOption from './AabSelectOption';

/**
 * For WAI ARIA guidelines on roles, states, aria-attributes, etc., see:
 * https://www.w3.org/TR/2019/WD-wai-aria-practices-1.2-20191218/examples/listbox/listbox-grouped.html
 *
 * @param {number} arg0.index the index of the group, in the context of the AabSelect
 * @param {string} arg0.name the (displayed) name of the group
 * @param {Array<Option>} arg0.options the options of the group
 * @param {string} arg0.value the value of the AabSelect
 * @param {number} arg0.focusedGroupIndex the index of the group which contains the 'focused' option
 * @param {number} arg0.focusedOptionIndex the index of the 'focused' option
 * @param {function} arg0.onOptionClick a callback for when a click event occurs on an option
 * @param {function} arg0.onOptionMouseOver a callback for when a mouseover event occurs on an option
 */
export default ({
  index,
  name,
  options,
  value,
  focusedGroupIndex,
  focusedOptionIndex,
  onOptionClick,
  onOptionMouseOver,
}) => html`
  <ul role="group" aria-labelledby="aab-option-label-${index}" class="group">
    <li
      id="aab-select-group-label-${index}"
      class="group__label"
      role="presentation"
    >
      <label>${name}</label>
    </li>

    ${options.map((option, optionIndex) => AabSelectOption({
    id: `aab-option-${index}-${optionIndex}`,
    isSelected: option.value === value,
    isFocused: focusedOptionIndex === optionIndex && focusedGroupIndex === index,
    disabled: option.disabled,
    name: option.name,
    icon: option.icon,
    onClick: onOptionClick,
    onMouseOver: () => onOptionMouseOver(optionIndex),
  }))}
  </ul>
`;
